import React, { useEffect } from 'react';
import { Row, Col } from "reactstrap";

import { useChat } from 'hooks/useChat';
import ChatMessageDisplay from 'components/Chat/ChatMessageDisplay';
import { imageAssets } from 'components/imageAssets';
import FooterInnerNav from 'components/Footers/FooterInnerNav';

const Chat = (props) => {
    const { id } = props;
    
    const {
        messages,
        userPrompt,
        isLoading,
        regenerateMessageId,
        setUserPrompt,
        scrollRef,
        formRef,
        textareaRef,
        handleSubmit,
        handleKeyDown,
        adjustTextareaHeight
    } = useChat(id);

    useEffect(() => {
        adjustTextareaHeight();
    }, [userPrompt, adjustTextareaHeight]);

    return (
        <>
            <div
                className="pt-md-0 mb-3 h-100 d-flex w-100 px-3 px-lg-1 bg-white"
                style={{ maxHeight: '85vh', overflowY: 'auto', overflowX: 'hidden' }}
                ref={scrollRef}
            >
                <Row className="mt-2 h-100 flex-grow-1 d-flex">
                    <Col className="h-100 flex-grow-1 d-flex" xl="12">
                        <div className="mb-0 mb-xl-0 h-100 flex-grow-1 d-flex flex-column">
                            <div className="pt-2 flex-grow-1">
                                <div className="p-0 h-100 position-relative">
                                    {messages && messages.length > 0 ? (
                                        <ChatMessageDisplay
                                            mapping={messages}
                                            sessionId={id}
                                            regenerateResponse={handleSubmit}
                                            regMsdId={regenerateMessageId}
                                            isLoading={isLoading}
                                            totalMessages={messages.length > 0 ? messages.length : 0}
                                        />
                                    ) : (
                                        <div className="flex h-100 flex-col text-center align-content-center text-token-text-primary">
                                            <div className="relative">
                                                <div className="assistant-mark mx-auto">
                                                    <img src={imageAssets.bluelogoicon} alt="" />
                                                </div>
                                            </div>
                                            <div className="mb-5 text-2xl font-medium text-black">
                                                How can I help you today?
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="justify-content-center sticky-bottom px-4 bg-white">
                <form ref={formRef} className="align-items-center w-75 mx-auto" onSubmit={handleSubmit}>
                    <div className="d-flex composer-box p-2" style={{ borderRadius: '20px' }}>
                        <textarea
                            name="messageInput"
                            className="border-0 bg-transparent form-control p-0 rounded-0 shadow-none mx-3 resize-none align-self-center"
                            placeholder="Message Bevan"
                            aria-label="Message Bevan input"
                            aria-describedby="button-addon2"
                            value={userPrompt}
                            onChange={(e) => {
                                setUserPrompt(e.target.value);
                                adjustTextareaHeight();
                            }}
                            onKeyDown={handleKeyDown}
                            rows="1"
                            ref={textareaRef}
                            style={{ overflowY: 'auto', maxHeight: '25dvh', }}
                        />
                        <button
                            className="btn send-btn mb-0 ml-2 p-0 text-white align-self-end"
                            type="submit"
                            disabled={!userPrompt.trim()}
                        >
                            {isLoading ? (
                                <span
                                    className="spinner-border spinner-border-sm text-light"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            ) : (
                                <i className="ni ni-send"></i>
                            )}
                        </button>
                    </div>
                </form>
                <p className="text-center text-xs mt-2 mb-0">
                    Bevan can make mistakes. Consider checking important information.
                </p>
                <FooterInnerNav />
            </div>
        </>
    );
};

export default Chat;
